import React, { useEffect, useState, useRef, LegacyRef } from 'react';
import './../css/Marker.css';
import { useTranslation } from 'react-i18next';

import groupPin from './../images/Marker/guide-group.svg';
import groupEmptyPin from './../images/Marker/Group-2.svg';
import guidePin from './../images/Marker/guide.svg';
import excursionPin from './../images/Marker/excursion.svg';
import excursionPlanedPin from './../images/Marker/excursion_planed.svg';
import routePin from './../images/Marker/Route.svg';
import creatingPin from './../images/Marker/creating.svg';
import myPosPin from './../images/Marker/my_pos.svg';
import { toast } from 'react-hot-toast';

enum EMarkerImage {
    guide = guidePin,
    group = groupPin,
    groupEmpty = groupEmptyPin,
    excursion = excursionPin,
    excursion_planed = excursionPlanedPin,
    route = routePin,
    creating = creatingPin,
    myPos = myPosPin,
}

interface IMarkerProps {
    key: string,
    count: number,
    type: 'guide' | 'excursion' | 'route' | 'group' | 'creating' | 'my_pos',
    radius?: number
    text?: string,
    actionDelete?: () => void
    image: EMarkerImage,
    lat: number,
    lng: number,
    infoGetter?: () => IMarkerInfo | Promise<IMarkerInfo | undefined>,
    handler?: () => void
}

interface IMarkerInfo {
    title: string,
    subTitle?: string,
    text?: string,
    imageUrl: string,
    redirectLink?: string
    action: {
        text: string,
        callback: (event: React.MouseEvent) => void,
    }
}

const Marker: React.FC<IMarkerProps> = ({ image, infoGetter, handler, actionDelete, text }) => {

    const { t } = useTranslation();

    const [showInfo, setShowInfo] = useState<boolean>(false);
    const [info, setInfo] = useState<IMarkerInfo>();

    const markerRef = useRef<HTMLDivElement>();

    const handle = () => {
        if (handler) {
            handler();
            return;
        }

        if (infoGetter) {
            toggleInfo();
        }
    }

    const toggleInfo = () => {
        setShowInfo(!showInfo);
    };

    useEffect(() => {
        const getInfo = async () => {
            if (infoGetter) {
                const newInfo = await infoGetter();
                if (newInfo) {
                    setInfo(newInfo);
                } else {
                    toast.error(t('error'));
                    setShowInfo(false);
                }
            }
        }

        if (showInfo && !info) {
            getInfo();
        }

        if (markerRef.current && markerRef.current.parentElement) {
            markerRef.current.parentElement.style.zIndex = showInfo ? '1' : '0';
        }
    }, [showInfo]);

    return (
        <div className={'map__marker ' + (showInfo ? 'map__marker--clicked' : '')} ref={(markerRef as LegacyRef<HTMLDivElement>)}>
            <div
                style={{
                    backgroundImage: 'url(' + image + ')'
                }}
                className='marker__pin'
                onClick={handle}
            >
                {actionDelete && (
                    <div className='marker__delete' onClick={(event) => {
                        actionDelete();
                        event.stopPropagation();
                    }}></div>
                )}

                {text}
            </div>

            {showInfo &&
                <div className='marker__info' onClick={() => {
                    if (info && info.redirectLink) {
                        window.open(info.redirectLink);
                    }
                }}>

                    <span className='marker__info-close' onClick={(event: React.MouseEvent) => {
                        toggleInfo();
                        event.stopPropagation();
                    }}></span>

                    {info ? (
                        <>
                            <div
                                className='marker__image'
                                style={{
                                    backgroundImage: 'url(' + info.imageUrl + ')'
                                }}
                            ></div>

                            <div className='marker__text-wrapper'>
                                <div className='marker__info-title'>
                                    {info.title}
                                </div>

                                {info.subTitle &&
                                    <div className='marker__info-subTitle'>
                                        {info.subTitle}
                                    </div>
                                }

                                {info.text &&
                                    <div
                                        className='marker__info-text'
                                        dangerouslySetInnerHTML={{ __html: info.text }}
                                    >
                                    </div>
                                }


                                {info.action.text &&
                                    <div className='marker__info-action' onClick={(event: React.MouseEvent) => {
                                        info.action.callback(event);
                                    }}>
                                        {info.action.text}
                                    </div>
                                }
                            </div>
                        </>
                    ) : (
                        <div className='marker__preloader'></div>
                    )}
                </div>
            }
        </div>
    );
};

export default Marker;

export { EMarkerImage };

export type { IMarkerProps };